<template>
<div class="specialListDialog">
    <el-dialog @close="cancel" title="内容选择" :visible.sync="dialogVisible" width="670px">
        <div class="filters">
            <div class="add flexstart"></div>
            <div class="search">
                <el-select v-model="param.newstypekind" placeholder="所属板块" class="condition" clearable>
                    <el-option v-for="item in newstypekindList" :key="item.code" :label="item.name"
                               :value="item.code"></el-option>
                </el-select>
                <el-input v-model="param.keyname" placeholder="请输入关键字" class="condition" clearable></el-input>
                <el-button type="primary" plain @click="handleQuery">搜索</el-button>
            </div>
        </div>
        <el-table :data="tableData" style="width: 100%" @select="handleSelectionChange" @row-click="handleRowChange" ref="multipleTable">
            <el-table-column type="selection" width="50"></el-table-column>
            <el-table-column prop="subject" label="标题" min-width="180px" class-name="title"></el-table-column>
            <el-table-column prop="newstypekindname" label="所属板块" class-name="tc" label-class-name="tc"></el-table-column>
        </el-table>
        <el-pagination background @current-change="_getList" :current-page.sync="page.page" :page-size="page.pageSize"
                       :pager-count="11" layout="prev, pager, next" :total="total">
        </el-pagination>
        <div slot="footer" class="dialog-footer" style="margin-top: 20px;">
            <el-button @click="cancel">取 消</el-button>
            <el-button type="primary" @click="submit">确 定</el-button>
        </div>
    </el-dialog>
</div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import {getQuestionbanktopiccontent} from 'api/questionApi'
import {special} from 'api/enumCode'
export default {
    name: 'specialListDialog',
    data() {
        return {
            dialogVisible: false,
            tableData: [],
            newstypekindList: special.newstypekind,
            param: {
                begintime: '',
                endtime: '',
                examcode: this.$route.query.examcode,
                examname: this.$route.query.examname,
                isrecommend: '',
                keyname: '',
                newstypekind: '',
                status: 1
            },
            page: {
                page: 1,
                pageSize: 10,
                pageCount: 0
            },
            total: 0,
            selectResult: {}
        }
    },
    mounted() {
    },
    methods: {
        handleSelectionChange(selection, row) {
            this.handleRowChange(row)
        },
        handleRowChange(row) {
            this.$refs.multipleTable.clearSelection()
            this.$refs.multipleTable.toggleRowSelection(row)
            this.selectResult = {
                contentinnerid: row.innerid,
                contentname: row.subject
            }
        },
        handleQuery() {
            this.page.page = 1
            this._getList()
        },
        cancel() {
            this.selectResult = {}
            this.dialogVisible = false
        },
        submit() {
            this.$emit('setContentinnerid', this.selectResult)
            this.cancel()
        },
        openDialog(examcode, row) {
            this.selectResult = row
            this.param.examcode = examcode
            this.tableData = []
            this._getList()
            this.dialogVisible = true
        },
        _getList() {
            this.setLoading(true)
            getQuestionbanktopiccontent({
                data: Object.assign({}, this.param, this.page),
                success: data => {
                    this.tableData = data.data.content
                    if (this.selectResult.contentinnerid) {
                        this.$nextTick(() => {
                            this.tableData.forEach((obj,i) => {
                                console.log(obj.innerid === this.selectResult.contentinnerid)
                                if(obj.innerid === this.selectResult.contentinnerid){

                                    this.$refs.multipleTable.toggleRowSelection(this.tableData[i])
                                    return false
                                }
                            })
                        })
                    }
                    this.total = data.data.pageinfo.rowCount
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions(['setLoading'])
    },
    filters: {},
    watch: {},
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.specialListDialog {
    .el-button{
        margin-bottom: 0;
    }
    th.el-table-column--selection{
        .cell{
            display: none;
        }
    }
    .el-table__row{
        cursor: pointer;
    }
}
</style>
